import React, { useState } from 'react';
import './styles/Header.css';
import logo from '../assets/images/Area51_Logo.png';
import ContactModal from './ContactModal'; // ✅ import the popup

const Header = () => {
  const [showModal, setShowModal] = useState(false);

  const handleContactClick = (e) => {
    e.preventDefault(); // prevent anchor from jumping
    setShowModal(true);
  };

  return (
    <>
      <header className="header">
        <div className="left">
          <img src={logo} alt="Logo" className="logo" />
          <span>Area 51</span>
          <nav className="nav-links">
            <a href="/">Home</a>
            <a href="#contact" onClick={handleContactClick}>Contact</a> {/* Styled same as Home */}
          </nav>
        </div>
      </header>

      {showModal && <ContactModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default Header;
